var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6719 21.9746C42.6719 28.3808 41.0761 32.6892 34.8082 38.4463C34.691 38.5558 21.4981 49.7815 21.4981 49.7815C21.4981 49.7815 8.24997 38.3655 8.13262 38.256C3.33964 34.0414 0.332031 28.3808 0.332031 21.9746C0.332031 10.2809 9.81216 0.808594 21.4981 0.808594C33.1918 0.808594 42.6719 10.2809 42.6719 21.9746Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4728 38.6589C30.7732 38.6589 38.3127 31.1194 38.3127 21.819C38.3127 12.5185 30.7732 4.979 21.4728 4.979C12.1723 4.979 4.63281 12.5185 4.63281 21.819C4.63281 31.1194 12.1723 38.6589 21.4728 38.6589Z",
    fill: "#FFCE55",
    stroke: "#FFAA00",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2305 17.9893H18.0229V25.6488H11.2305",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7143 25.6488H24.9219V17.9893H31.7143",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0234 21.8188H24.9225",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.332031 0.808594)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDam);
export default __webpack_public_path__ + "static/media/check-dam.2c9b53f11a1ca0eaaae544fb2145953e.svg";
export { ForwardRef as ReactComponent };